import React from 'react'
interface props {
  returnid: (e: string) => void
  selected: string
}
export const TileMap = ({ returnid, selected }: props) => {
  return (
    <svg
      viewBox='0 0 1002 802'
      enableBackground='new 0 0 1002 80¯2'
      className='map'
      onClick={(e: React.MouseEvent) => {
        let t = e.target
        if (!t) return
        let id = (t as SVGSVGElement).parentElement.id
        if (id) returnid(id)
      }}
    >
      <g id='JU' className={selected === 'JU' ? 'sel' : ''}>
        <rect x='202.5' y='135.83' width='130.33' height='130.33' />
      </g>
      <g id='NE' className={selected === 'NE' ? 'sel' : ''}>
        <rect x='202.5' y='269.17' width='130.33' height='130.33' />
      </g>
      <g id='FR' className={selected === 'FR' ? 'sel' : ''}>
        <rect x='202.5' y='402.5' width='130.33' height='130.33' />
      </g>
      <g id='VD' className={selected === 'VD' ? 'sel' : ''}>
        <rect x='69.17' y='402.5' width='130.33' height='130.33' />
      </g>
      <g id='GE' className={selected === 'GE' ? 'sel' : ''}>
        <rect x='2.5' y='535.83' width='130.33' height='130.33' />
      </g>
      <g id='VS' className={selected === 'VS' ? 'sel' : ''}>
        <rect x='269.17' y='535.83' width='130.33' height='130.33' />
      </g>
      <g id='SO' className={selected === 'SO' ? 'sel' : ''}>
        <rect x='335.83' y='269.17' width='130.33' height='130.33' />
      </g>
      <g id='BS' className={selected === 'BS' ? 'sel' : ''}>
        <polygon points='335.83,135.83 335.83,264.05 464.05,135.83' />
      </g>
      <g id='BL' className={selected === 'BL' ? 'sel' : ''}>
        <polygon points='466.17,266.17 466.17,137.95 337.95,266.17' />
      </g>
      <g id='BE' className={selected === 'BE' ? 'sel' : ''}>
        <rect x='335.83' y='402.5' width='130.33' height='130.33' />
      </g>
      <g id='AG' className={selected === 'AG' ? 'sel' : ''}>
        <rect x='469.17' y='135.83' width='130.33' height='130.33' />
      </g>
      <g id='LU' className={selected === 'LU' ? 'sel' : ''}>
        <rect x='469.17' y='269.17' width='130.33' height='130.33' />
      </g>
      <g id='OW' className={selected === 'OW' ? 'sel' : ''}>
        <polygon points='469.17,402.5 469.17,530.71 597.38,402.5' />
      </g>
      <g id='NW' className={selected === 'NW' ? 'sel' : ''}>
        <polygon points='599.5,532.83 599.5,404.62 471.29,532.83' />
      </g>
      <g id='TI' className={selected === 'TI' ? 'sel' : ''}>
        <rect x='602.5' y='669.17' width='130.33' height='130.33' />
      </g>
      <g id='UR' className={selected === 'UR' ? 'sel' : ''}>
        <rect x='602.5' y='535.83' width='130.33' height='130.33' />
      </g>
      <g id='SZ' className={selected === 'SZ' ? 'sel' : ''}>
        <rect x='602.5' y='402.5' width='130.33' height='130.33' />
      </g>
      <g id='ZG' className={selected === 'ZG' ? 'sel' : ''}>
        <rect x='602.5' y='269.17' width='130.33' height='130.33' />
      </g>
      <g id='ZH' className={selected === 'ZH' ? 'sel' : ''}>
        <rect x='602.5' y='135.83' width='130.33' height='130.33' />
      </g>
      <g id='SH' className={selected === 'SH' ? 'sel' : ''}>
        <rect x='602.5' y='2.5' width='130.33' height='130.33' />
      </g>
      <g id='TG' className={selected === 'TG' ? 'sel' : ''}>
        <rect x='735.83' y='135.83' width='130.33' height='130.33' />
      </g>
      <g id='SG' className={selected === 'SG' ? 'sel' : ''}>
        <rect x='735.83' y='269.17' width='130.33' height='130.33' />
      </g>
      <g id='GL' className={selected === 'GL' ? 'sel' : ''}>
        <rect x='735.83' y='402.5' width='130.33' height='130.33' />
      </g>
      <g id='GR' className={selected === 'GR' ? 'sel' : ''}>
        <rect x='869.17' y='402.5' width='130.33' height='130.33' />
      </g>
      <g id='AR' className={selected === 'AR' ? 'sel' : ''}>
        <polygon points='869.17,202.5 869.17,330.71 997.38,202.5' />
      </g>
      <g id='AI' className={selected === 'AI' ? 'sel' : ''}>
        <polygon points='999.5,332.83 999.5,204.62 871.29,332.83' />
      </g>
      <g id='LABELS'>
        <path
          d='M261.07,188.11v21.01c0,1.27-0.21,2.41-0.62,3.43c-0.41,1.02-1,1.9-1.76,2.63
			c-0.76,0.73-1.68,1.3-2.77,1.7c-1.09,0.4-2.29,0.6-3.62,0.6c-2.51,0-4.49-0.66-5.94-1.99c-1.45-1.32-2.37-3.06-2.75-5.21l4.3-0.95
			c0.25,1.24,0.72,2.22,1.43,2.94c0.7,0.72,1.69,1.08,2.96,1.08c1.24,0,2.23-0.39,2.98-1.16c0.74-0.77,1.12-1.95,1.12-3.52V192
			h-9.43v-3.89H261.07z'
        />
        <path
          d='M272.44,188.11v17.82c0,2.46,0.47,4.31,1.41,5.55c0.94,1.24,2.54,1.86,4.8,1.86c2.26,0,3.86-0.62,4.8-1.86
			c0.94-1.24,1.41-3.09,1.41-5.55v-17.82h4.59v17.04c0,2.12-0.19,3.96-0.58,5.5c-0.39,1.54-1.01,2.82-1.86,3.83
			c-0.86,1.01-1.96,1.76-3.33,2.25c-1.37,0.5-3.04,0.74-5.03,0.74s-3.66-0.25-5.03-0.74c-1.36-0.5-2.47-1.25-3.33-2.25
			c-0.86-1.01-1.48-2.28-1.86-3.83c-0.39-1.54-0.58-3.38-0.58-5.5v-17.04H272.44z'
        />
        <path
          d='M251.97,334.35l-3.18-6.12h-0.12v22.09h-4.47v-28.87h5.21l9.43,15.97l3.19,6.12h0.12v-22.09h4.47v28.87
			h-5.21L251.97,334.35z'
        />
        <path d='M273.73,350.32v-28.87h18.49v4.14H278.4v8.02h12.53v4.14H278.4v8.44h13.82v4.14H273.73z' />
        <path d='M245.89,483.65v-28.87h18.04v4.14h-13.36v8.02h11.87v4.14h-11.87v12.58H245.89z' />
        <path
          d='M274.14,483.65h-4.67v-28.87h12.45c2.59,0,4.63,0.78,6.12,2.34c1.49,1.56,2.23,3.67,2.23,6.35
			c0,2.07-0.48,3.79-1.43,5.15s-2.35,2.32-4.2,2.88l6.25,12.16h-5.21l-5.79-11.67h-5.75V483.65z M281.58,468.06
			c1.19,0,2.11-0.31,2.77-0.93c0.66-0.62,0.99-1.5,0.99-2.66v-1.98c0-1.15-0.33-2.04-0.99-2.66c-0.66-0.62-1.59-0.93-2.77-0.93
			h-7.45v9.14H281.58z'
        />

        <path
          d='M117.44,483.65l-9.47-28.87h4.84l4.59,14.27l2.77,10.05h0.17l2.81-10.05l4.59-14.27h4.72l-9.6,28.87
			H117.44z'
        />
        <path
          d='M136.75,454.78h10.22c1.85,0,3.52,0.3,5.03,0.91s2.79,1.51,3.85,2.71c1.06,1.2,1.88,2.7,2.46,4.51
			c0.58,1.81,0.87,3.91,0.87,6.31s-0.29,4.5-0.87,6.31s-1.4,3.31-2.46,4.51c-1.06,1.2-2.34,2.1-3.85,2.71
			c-1.5,0.61-3.18,0.91-5.03,0.91h-10.22V454.78z M146.97,479.52c2.15,0,3.89-0.67,5.21-2.03c1.32-1.35,1.99-3.34,1.99-5.96v-4.63
			c0-2.62-0.66-4.61-1.99-5.96c-1.32-1.35-3.06-2.03-5.21-2.03h-5.54v20.6H146.97z'
        />
        <path
          d='M62.95,612.64h-0.17c-0.3,1.4-1.12,2.55-2.46,3.47c-1.34,0.92-3.11,1.38-5.32,1.38
			c-1.71,0-3.3-0.32-4.76-0.97c-1.46-0.65-2.72-1.6-3.79-2.85s-1.89-2.81-2.48-4.67s-0.89-4-0.89-6.43c0-2.4,0.3-4.53,0.91-6.39
			c0.61-1.86,1.46-3.43,2.56-4.7c1.1-1.27,2.43-2.23,3.97-2.88c1.54-0.65,3.27-0.97,5.17-0.97c2.59,0,4.78,0.57,6.58,1.71
			s3.19,2.73,4.18,4.77l-3.81,2.23c-0.55-1.36-1.41-2.46-2.57-3.3s-2.62-1.27-4.38-1.27c-2.29,0-4.13,0.73-5.52,2.2
			c-1.39,1.47-2.09,3.54-2.09,6.23v4.73c0,2.69,0.7,4.76,2.09,6.23c1.39,1.47,3.23,2.2,5.52,2.2c0.91,0,1.78-0.12,2.61-0.35
			c0.83-0.24,1.55-0.58,2.17-1.04c0.62-0.46,1.12-1.03,1.49-1.71c0.37-0.68,0.56-1.48,0.56-2.39v-2.25h-5.96v-4.01h10.47v15.39h-4.1
			V612.64z'
        />
        <path d='M73.54,616.99v-28.87h18.49v4.14H78.21v8.03h12.53v4.14H78.21v8.44h13.82v4.14H73.54z' />
        <path
          d='M319.59,616.99l-9.47-28.87h4.84l4.59,14.27l2.77,10.05h0.17l2.81-10.05l4.59-14.27h4.72l-9.6,28.87
			H319.59z'
        />
        <path
          d='M346.76,617.48c-2.43,0-4.49-0.44-6.18-1.32c-1.7-0.88-3.15-2.07-4.36-3.56l3.23-3.02
			c1.02,1.24,2.14,2.18,3.37,2.81c1.23,0.63,2.63,0.95,4.2,0.95c1.85,0,3.24-0.41,4.18-1.24c0.94-0.83,1.41-1.94,1.41-3.35
			c0-1.13-0.33-2.03-0.99-2.69s-1.83-1.16-3.52-1.49l-2.56-0.46c-2.81-0.52-4.92-1.45-6.33-2.77c-1.41-1.32-2.11-3.14-2.11-5.46
			c0-1.27,0.24-2.42,0.72-3.45s1.16-1.9,2.03-2.61c0.87-0.7,1.92-1.25,3.16-1.63c1.24-0.39,2.63-0.58,4.18-0.58
			c2.18,0,4.07,0.38,5.67,1.14c1.6,0.76,2.96,1.85,4.09,3.29l-3.27,2.9c-0.75-0.96-1.66-1.74-2.73-2.32s-2.41-0.87-4.01-0.87
			c-1.65,0-2.94,0.33-3.85,0.99c-0.91,0.66-1.37,1.63-1.37,2.9c0,1.21,0.37,2.12,1.12,2.71c0.74,0.59,1.9,1.04,3.47,1.34l2.56,0.54
			c2.9,0.55,5.01,1.49,6.35,2.81c1.34,1.32,2.01,3.14,2.01,5.46c0,1.35-0.24,2.58-0.7,3.68c-0.47,1.1-1.15,2.05-2.05,2.83
			c-0.9,0.79-1.99,1.39-3.29,1.82C349.89,617.27,348.42,617.48,346.76,617.48z'
        />

        <path
          d='M386.11,350.82c-2.43,0-4.49-0.44-6.18-1.32c-1.7-0.88-3.15-2.07-4.36-3.56l3.23-3.02
			c1.02,1.24,2.14,2.18,3.37,2.81c1.23,0.63,2.63,0.95,4.2,0.95c1.85,0,3.24-0.41,4.18-1.24c0.94-0.83,1.41-1.94,1.41-3.35
			c0-1.13-0.33-2.03-0.99-2.69c-0.66-0.66-1.83-1.16-3.52-1.49l-2.56-0.46c-2.81-0.52-4.92-1.45-6.33-2.77s-2.11-3.14-2.11-5.46
			c0-1.27,0.24-2.42,0.72-3.45s1.16-1.9,2.03-2.61c0.87-0.7,1.92-1.25,3.16-1.63c1.24-0.39,2.63-0.58,4.18-0.58
			c2.18,0,4.07,0.38,5.67,1.14c1.6,0.76,2.96,1.85,4.09,3.29l-3.27,2.9c-0.75-0.96-1.66-1.74-2.73-2.32s-2.41-0.87-4.01-0.87
			c-1.65,0-2.94,0.33-3.85,0.99c-0.91,0.66-1.37,1.63-1.37,2.9c0,1.21,0.37,2.12,1.12,2.71c0.74,0.59,1.9,1.04,3.47,1.34l2.56,0.54
			c2.9,0.55,5.01,1.49,6.35,2.81s2.01,3.14,2.01,5.46c0,1.35-0.24,2.58-0.7,3.68c-0.47,1.1-1.15,2.05-2.05,2.83
			c-0.9,0.79-1.99,1.39-3.29,1.82C389.24,350.6,387.76,350.82,386.11,350.82z'
        />
        <path
          d='M413.37,350.82c-1.88,0-3.58-0.32-5.11-0.97c-1.53-0.65-2.84-1.6-3.93-2.85
			c-1.09-1.25-1.93-2.81-2.52-4.67s-0.89-4.01-0.89-6.43c0-2.43,0.3-4.57,0.89-6.43s1.43-3.42,2.52-4.67s2.4-2.21,3.93-2.85
			c1.53-0.65,3.23-0.97,5.11-0.97c1.88,0,3.58,0.32,5.11,0.97c1.53,0.65,2.84,1.6,3.93,2.85c1.09,1.25,1.93,2.81,2.52,4.67
			s0.89,4.01,0.89,6.43c0,2.43-0.3,4.57-0.89,6.43s-1.43,3.42-2.52,4.67c-1.09,1.26-2.4,2.21-3.93,2.85
			C416.95,350.49,415.24,350.82,413.37,350.82z M413.37,346.68c1.1,0,2.12-0.19,3.04-0.58s1.71-0.95,2.36-1.68
			c0.65-0.73,1.15-1.63,1.51-2.68c0.36-1.05,0.54-2.24,0.54-3.57v-4.57c0-1.33-0.18-2.52-0.54-3.57c-0.36-1.05-0.86-1.94-1.51-2.68
			c-0.65-0.73-1.43-1.29-2.36-1.68c-0.92-0.39-1.94-0.58-3.04-0.58c-1.13,0-2.15,0.19-3.06,0.58c-0.91,0.39-1.69,0.95-2.34,1.68
			c-0.65,0.73-1.15,1.63-1.51,2.68s-0.54,2.24-0.54,3.57v4.57c0,1.33,0.18,2.52,0.54,3.57s0.86,1.94,1.51,2.68
			c0.65,0.73,1.43,1.29,2.34,1.68S412.24,346.68,413.37,346.68z'
        />
        <path
          d='M352.58,158.68h12.78c2.4,0,4.28,0.68,5.65,2.03c1.37,1.35,2.05,3.16,2.05,5.42
			c0,1.08-0.15,1.99-0.46,2.75c-0.3,0.76-0.69,1.38-1.16,1.86c-0.47,0.48-1.01,0.84-1.61,1.08c-0.61,0.23-1.2,0.38-1.78,0.43v0.25
			c0.58,0.03,1.22,0.17,1.92,0.41s1.36,0.64,1.96,1.18c0.61,0.54,1.12,1.23,1.53,2.07c0.41,0.84,0.62,1.87,0.62,3.08
			c0,1.16-0.19,2.25-0.56,3.27c-0.37,1.02-0.89,1.9-1.55,2.65s-1.45,1.33-2.36,1.76c-0.91,0.43-1.9,0.64-2.98,0.64h-14.06V158.68z
			 M357.26,170.88h7.24c1.16,0,2.05-0.3,2.69-0.89c0.63-0.59,0.95-1.44,0.95-2.54v-1.32c0-1.1-0.32-1.95-0.95-2.54
			c-0.63-0.59-1.53-0.89-2.69-0.89h-7.24V170.88z M357.26,183.54h8.03c1.21,0,2.17-0.32,2.85-0.95c0.69-0.63,1.03-1.54,1.03-2.73
			v-1.41c0-1.19-0.35-2.1-1.03-2.73c-0.69-0.63-1.64-0.95-2.85-0.95h-8.03V183.54z'
        />
        <path
          d='M388.49,188.05c-2.43,0-4.49-0.44-6.18-1.32c-1.7-0.88-3.15-2.07-4.36-3.56l3.23-3.02
			c1.02,1.24,2.14,2.18,3.37,2.81c1.23,0.63,2.63,0.95,4.2,0.95c1.85,0,3.24-0.41,4.18-1.24c0.94-0.83,1.41-1.94,1.41-3.35
			c0-1.13-0.33-2.03-0.99-2.69c-0.66-0.66-1.83-1.16-3.52-1.49l-2.56-0.46c-2.81-0.52-4.92-1.45-6.33-2.77s-2.11-3.14-2.11-5.46
			c0-1.27,0.24-2.42,0.72-3.45s1.16-1.9,2.03-2.61c0.87-0.7,1.92-1.25,3.16-1.63c1.24-0.39,2.63-0.58,4.18-0.58
			c2.18,0,4.07,0.38,5.67,1.14c1.6,0.76,2.96,1.85,4.09,3.29l-3.27,2.9c-0.75-0.96-1.66-1.74-2.73-2.32s-2.41-0.87-4.01-0.87
			c-1.65,0-2.94,0.33-3.85,0.99c-0.91,0.66-1.37,1.63-1.37,2.9c0,1.21,0.37,2.12,1.12,2.71c0.74,0.59,1.9,1.04,3.47,1.34l2.56,0.54
			c2.9,0.55,5.01,1.49,6.35,2.81s2.01,3.14,2.01,5.46c0,1.35-0.24,2.58-0.7,3.68c-0.47,1.1-1.15,2.05-2.05,2.83
			c-0.9,0.79-1.99,1.39-3.29,1.82C391.62,187.83,390.14,188.05,388.49,188.05z'
        />
        <path
          d='M408.17,212.5h12.78c2.4,0,4.28,0.68,5.65,2.03c1.37,1.35,2.05,3.16,2.05,5.42c0,1.08-0.15,1.99-0.46,2.75
			c-0.3,0.76-0.69,1.38-1.16,1.86c-0.47,0.48-1.01,0.84-1.61,1.08c-0.61,0.23-1.2,0.38-1.78,0.43v0.25
			c0.58,0.03,1.22,0.17,1.92,0.41s1.36,0.64,1.96,1.18c0.61,0.54,1.12,1.23,1.53,2.07c0.41,0.84,0.62,1.87,0.62,3.08
			c0,1.16-0.19,2.25-0.56,3.27c-0.37,1.02-0.89,1.9-1.55,2.65s-1.45,1.33-2.36,1.76c-0.91,0.43-1.9,0.64-2.98,0.64h-14.06V212.5z
			 M412.84,224.7h7.24c1.16,0,2.05-0.3,2.69-0.89c0.63-0.59,0.95-1.44,0.95-2.54v-1.32c0-1.1-0.32-1.95-0.95-2.54
			c-0.63-0.59-1.53-0.89-2.69-0.89h-7.24V224.7z M412.84,237.36h8.03c1.21,0,2.17-0.32,2.85-0.95c0.69-0.63,1.03-1.54,1.03-2.73
			v-1.41c0-1.19-0.35-2.1-1.03-2.73c-0.69-0.63-1.64-0.95-2.85-0.95h-8.03V237.36z'
        />
        <path d='M435.43,241.37V212.5h4.67v24.74h11.75v4.14H435.43z' />
        <path
          d='M378.66,454.78h12.78c2.4,0,4.28,0.68,5.65,2.03c1.37,1.35,2.05,3.16,2.05,5.42
			c0,1.08-0.15,1.99-0.46,2.75c-0.3,0.76-0.69,1.38-1.16,1.86c-0.47,0.48-1.01,0.84-1.61,1.08c-0.61,0.23-1.2,0.38-1.78,0.43v0.25
			c0.58,0.03,1.22,0.17,1.92,0.41s1.36,0.64,1.96,1.18c0.61,0.54,1.12,1.23,1.53,2.07c0.41,0.84,0.62,1.87,0.62,3.08
			c0,1.16-0.19,2.25-0.56,3.27c-0.37,1.02-0.89,1.9-1.55,2.65c-0.66,0.75-1.45,1.33-2.36,1.76s-1.9,0.64-2.98,0.64h-14.06V454.78z
			 M383.34,466.98h7.24c1.16,0,2.05-0.3,2.69-0.89c0.63-0.59,0.95-1.44,0.95-2.54v-1.32c0-1.1-0.32-1.95-0.95-2.54
			c-0.63-0.59-1.53-0.89-2.69-0.89h-7.24V466.98z M383.34,479.64h8.03c1.21,0,2.17-0.32,2.85-0.95c0.69-0.63,1.03-1.54,1.03-2.73
			v-1.41c0-1.19-0.35-2.09-1.03-2.73c-0.69-0.63-1.64-0.95-2.85-0.95h-8.03V479.64z'
        />
        <path d='M405.92,483.65v-28.87h18.49v4.14H410.6v8.02h12.53v4.14H410.6v8.44h13.82v4.14H405.92z' />
        <path
          d='M528.09,216.99l-2.61-7.82h-10.8l-2.52,7.82h-4.76l9.84-28.87h5.87l9.85,28.87H528.09z M520.19,192.42
			h-0.21l-4.18,12.74h8.52L520.19,192.42z'
        />
        <path
          d='M555.14,212.64h-0.17c-0.3,1.4-1.12,2.55-2.46,3.47s-3.11,1.38-5.32,1.38c-1.71,0-3.3-0.32-4.76-0.97
			c-1.46-0.65-2.72-1.6-3.79-2.85c-1.06-1.25-1.89-2.81-2.48-4.67s-0.89-4.01-0.89-6.43c0-2.4,0.3-4.53,0.91-6.39
			c0.61-1.86,1.46-3.43,2.56-4.7c1.1-1.27,2.43-2.23,3.97-2.88c1.54-0.65,3.27-0.97,5.17-0.97c2.59,0,4.78,0.57,6.58,1.71
			c1.79,1.14,3.19,2.73,4.18,4.77l-3.81,2.23c-0.55-1.36-1.41-2.46-2.57-3.3s-2.62-1.27-4.38-1.27c-2.29,0-4.13,0.73-5.52,2.2
			c-1.39,1.47-2.09,3.54-2.09,6.23v4.73c0,2.69,0.7,4.76,2.09,6.23c1.39,1.47,3.23,2.2,5.52,2.2c0.91,0,1.78-0.12,2.61-0.35
			c0.83-0.24,1.55-0.58,2.17-1.04c0.62-0.46,1.12-1.03,1.49-1.71c0.37-0.68,0.56-1.48,0.56-2.39v-2.25h-5.96v-4.01h10.47v15.39h-4.1
			V212.64z'
        />
        <path d='M513.71,350.32v-28.87h4.67v24.74h11.75v4.14H513.71z' />
        <path
          d='M538.12,321.45v17.82c0,2.46,0.47,4.31,1.41,5.55c0.94,1.24,2.54,1.86,4.8,1.86c2.26,0,3.86-0.62,4.8-1.86
			c0.94-1.24,1.41-3.09,1.41-5.55v-17.82h4.59v17.04c0,2.12-0.19,3.96-0.58,5.5c-0.39,1.54-1.01,2.82-1.86,3.83
			c-0.86,1.01-1.96,1.76-3.33,2.25c-1.37,0.5-3.04,0.74-5.03,0.74s-3.66-0.25-5.03-0.74c-1.36-0.5-2.47-1.25-3.33-2.25
			c-0.86-1.01-1.48-2.28-1.86-3.83c-0.39-1.54-0.58-3.38-0.58-5.5v-17.04H538.12z'
        />
        <path
          d='M490.41,449.71c-1.88,0-3.58-0.32-5.11-0.97c-1.53-0.65-2.84-1.6-3.93-2.85s-1.93-2.81-2.52-4.67
			s-0.89-4-0.89-6.43c0-2.43,0.3-4.57,0.89-6.43s1.43-3.42,2.52-4.67s2.4-2.21,3.93-2.85c1.53-0.65,3.23-0.97,5.11-0.97
			c1.88,0,3.58,0.32,5.11,0.97c1.53,0.65,2.84,1.6,3.93,2.85c1.09,1.25,1.93,2.81,2.52,4.67s0.89,4.01,0.89,6.43
			c0,2.43-0.3,4.57-0.89,6.43s-1.43,3.42-2.52,4.67c-1.09,1.25-2.4,2.21-3.93,2.85C493.99,449.39,492.29,449.71,490.41,449.71z
			 M490.41,445.58c1.1,0,2.12-0.19,3.04-0.58s1.71-0.95,2.36-1.68c0.65-0.73,1.15-1.63,1.51-2.68c0.36-1.05,0.54-2.24,0.54-3.57
			v-4.57c0-1.33-0.18-2.52-0.54-3.57c-0.36-1.05-0.86-1.94-1.51-2.68c-0.65-0.73-1.43-1.29-2.36-1.68
			c-0.92-0.39-1.94-0.58-3.04-0.58c-1.13,0-2.15,0.19-3.06,0.58c-0.91,0.39-1.69,0.95-2.34,1.68c-0.65,0.73-1.15,1.63-1.51,2.68
			c-0.36,1.05-0.54,2.24-0.54,3.57v4.57c0,1.33,0.18,2.52,0.54,3.57c0.36,1.05,0.86,1.95,1.51,2.68c0.65,0.73,1.43,1.29,2.34,1.68
			S489.28,445.58,490.41,445.58z'
        />
        <path
          d='M512.54,449.22l-6.83-28.87h4.76l2.94,13.9l2.03,9.6h0.12l2.32-9.6l3.43-13.9h5.21l3.39,13.9l2.27,9.56
			h0.12l2.11-9.56l3.02-13.9h4.59l-7.12,28.87h-5.25l-3.68-14.93l-2.15-8.77h-0.08l-2.19,8.77l-3.76,14.93H512.54z'
        />

        <path
          d='M537.6,499.07l-3.18-6.12h-0.12v22.09h-4.47v-28.87h5.21l9.43,15.97l3.19,6.12h0.12v-22.09h4.47v28.87
			h-5.21L537.6,499.07z'
        />
        <path
          d='M563.62,515.04l-6.83-28.87h4.76l2.94,13.9l2.03,9.6h0.12l2.32-9.6l3.43-13.9h5.21l3.39,13.9l2.27,9.56
			h0.12l2.11-9.56l3.02-13.9h4.59L586,515.04h-5.25l-3.68-14.93l-2.15-8.77h-0.08l-2.19,8.77l-3.76,14.93H563.62z'
        />

        <path d='M661.52,725.58v24.74h-4.67v-24.74h-8.6v-4.14h21.88v4.14H661.52z' />
        <path d='M673.19,750.32v-3.81h3.93v-21.26h-3.93v-3.81h12.58v3.81h-3.97v21.26h3.97v3.81H673.19z' />

        <path
          d='M647.91,588.11v17.82c0,2.46,0.47,4.31,1.41,5.55c0.94,1.24,2.54,1.86,4.8,1.86c2.26,0,3.86-0.62,4.8-1.86
			c0.94-1.24,1.41-3.09,1.41-5.55v-17.82h4.59v17.04c0,2.12-0.19,3.96-0.58,5.5c-0.39,1.54-1.01,2.82-1.86,3.83
			c-0.86,1.01-1.96,1.76-3.33,2.25c-1.37,0.5-3.04,0.74-5.03,0.74s-3.66-0.25-5.03-0.74c-1.36-0.5-2.47-1.25-3.33-2.25
			c-0.86-1.01-1.48-2.28-1.86-3.83c-0.39-1.54-0.58-3.38-0.58-5.5v-17.04H647.91z'
        />
        <path
          d='M676.54,616.99h-4.67v-28.87h12.45c2.59,0,4.63,0.78,6.12,2.34c1.49,1.56,2.23,3.67,2.23,6.35
			c0,2.07-0.48,3.78-1.43,5.15s-2.35,2.32-4.2,2.88l6.25,12.16h-5.21l-5.79-11.67h-5.75V616.99z M683.99,601.39
			c1.19,0,2.11-0.31,2.77-0.93s0.99-1.5,0.99-2.66v-1.98c0-1.15-0.33-2.04-0.99-2.66s-1.59-0.93-2.77-0.93h-7.45v9.14H683.99z'
        />

        <path
          d='M655.28,484.15c-2.43,0-4.49-0.44-6.18-1.32c-1.7-0.88-3.15-2.07-4.36-3.56l3.23-3.02
			c1.02,1.24,2.14,2.18,3.37,2.81c1.23,0.63,2.63,0.95,4.2,0.95c1.85,0,3.24-0.41,4.18-1.24s1.41-1.94,1.41-3.35
			c0-1.13-0.33-2.03-0.99-2.69c-0.66-0.66-1.83-1.16-3.52-1.49l-2.56-0.46c-2.81-0.52-4.92-1.45-6.33-2.77
			c-1.41-1.32-2.11-3.14-2.11-5.46c0-1.27,0.24-2.42,0.72-3.45s1.16-1.9,2.03-2.61c0.87-0.7,1.92-1.25,3.16-1.63
			c1.24-0.39,2.63-0.58,4.18-0.58c2.18,0,4.07,0.38,5.67,1.14c1.6,0.76,2.96,1.86,4.09,3.29l-3.27,2.9
			c-0.75-0.96-1.66-1.74-2.73-2.32s-2.41-0.87-4.01-0.87c-1.65,0-2.94,0.33-3.85,0.99s-1.37,1.63-1.37,2.9
			c0,1.21,0.37,2.12,1.12,2.71c0.74,0.59,1.9,1.04,3.47,1.34l2.56,0.54c2.9,0.55,5.01,1.49,6.35,2.81c1.34,1.32,2.01,3.14,2.01,5.46
			c0,1.35-0.24,2.58-0.7,3.68c-0.47,1.1-1.15,2.05-2.05,2.83c-0.9,0.79-1.99,1.39-3.29,1.82S656.93,484.15,655.28,484.15z'
        />
        <path d='M690.73,483.65h-21.39v-4.18l15.68-20.56h-14.85v-4.14h20.1v4.18l-15.68,20.56h16.13V483.65z' />

        <path d='M664.11,350.32h-21.39v-4.18l15.68-20.56h-14.85v-4.14h20.1v4.18l-15.68,20.56h16.13V350.32z' />
        <path
          d='M687.11,345.97h-0.17c-0.3,1.4-1.12,2.55-2.46,3.47s-3.11,1.38-5.32,1.38c-1.71,0-3.3-0.32-4.76-0.97
			c-1.46-0.65-2.72-1.6-3.79-2.85c-1.06-1.25-1.89-2.81-2.48-4.67s-0.89-4.01-0.89-6.43c0-2.4,0.3-4.53,0.91-6.39
			c0.61-1.86,1.46-3.43,2.56-4.7c1.1-1.27,2.43-2.23,3.97-2.88c1.54-0.65,3.27-0.97,5.17-0.97c2.59,0,4.78,0.57,6.58,1.71
			c1.79,1.14,3.19,2.73,4.18,4.77l-3.81,2.23c-0.55-1.36-1.41-2.46-2.57-3.3s-2.62-1.27-4.38-1.27c-2.29,0-4.13,0.73-5.52,2.2
			c-1.39,1.47-2.09,3.54-2.09,6.23v4.73c0,2.69,0.7,4.76,2.09,6.23c1.39,1.47,3.23,2.2,5.52,2.2c0.91,0,1.78-0.12,2.61-0.35
			c0.83-0.24,1.55-0.58,2.17-1.04c0.62-0.46,1.12-1.03,1.49-1.71c0.37-0.68,0.56-1.48,0.56-2.39v-2.25h-5.96v-4.01h10.47v15.39h-4.1
			V345.97z'
        />
        <path d='M663.59,216.99h-21.39v-4.18l15.68-20.56h-14.85v-4.14h20.1v4.18l-15.68,20.56h16.13V216.99z' />
        <path d='M686.43,204.41h-13.07v12.58h-4.67v-28.87h4.67v12.16h13.07v-12.16h4.67v28.87h-4.67V204.41z' />

        <path
          d='M652.73,84.15c-2.43,0-4.49-0.44-6.18-1.32c-1.7-0.88-3.15-2.07-4.36-3.56l3.23-3.02
			c1.02,1.24,2.14,2.18,3.37,2.81c1.23,0.63,2.63,0.95,4.2,0.95c1.85,0,3.24-0.41,4.18-1.24c0.94-0.83,1.41-1.94,1.41-3.35
			c0-1.13-0.33-2.03-0.99-2.69c-0.66-0.66-1.83-1.16-3.52-1.49l-2.56-0.46c-2.81-0.52-4.92-1.45-6.33-2.77s-2.11-3.14-2.11-5.46
			c0-1.27,0.24-2.42,0.72-3.45s1.16-1.9,2.03-2.61c0.87-0.7,1.92-1.25,3.16-1.63c1.24-0.39,2.63-0.58,4.18-0.58
			c2.18,0,4.07,0.38,5.67,1.14c1.6,0.76,2.96,1.85,4.09,3.29l-3.27,2.9c-0.75-0.96-1.66-1.74-2.73-2.32s-2.41-0.87-4.01-0.87
			c-1.65,0-2.94,0.33-3.85,0.99c-0.91,0.66-1.37,1.63-1.37,2.9c0,1.21,0.37,2.12,1.12,2.71c0.74,0.59,1.9,1.04,3.47,1.34l2.56,0.54
			c2.9,0.55,5.01,1.49,6.35,2.81s2.01,3.14,2.01,5.46c0,1.35-0.24,2.58-0.7,3.68c-0.47,1.1-1.15,2.05-2.05,2.83
			c-0.9,0.79-1.99,1.39-3.29,1.82C655.86,83.94,654.39,84.15,652.73,84.15z'
        />
        <path d='M686.57,71.08H673.5v12.58h-4.67V54.78h4.67v12.16h13.07V54.78h4.67v28.87h-4.67V71.08z' />

        <path d='M789.21,192.25v24.74h-4.67v-24.74h-8.6v-4.14h21.88v4.14H789.21z' />
        <path
          d='M820.03,212.64h-0.17c-0.3,1.4-1.12,2.55-2.46,3.47s-3.11,1.38-5.32,1.38c-1.71,0-3.3-0.32-4.76-0.97
			c-1.46-0.65-2.72-1.6-3.79-2.85c-1.06-1.25-1.89-2.81-2.48-4.67s-0.89-4.01-0.89-6.43c0-2.4,0.3-4.53,0.91-6.39
			c0.61-1.86,1.46-3.43,2.56-4.7c1.1-1.27,2.43-2.23,3.97-2.88c1.54-0.65,3.27-0.97,5.17-0.97c2.59,0,4.78,0.57,6.58,1.71
			c1.79,1.14,3.19,2.73,4.18,4.77l-3.81,2.23c-0.55-1.36-1.41-2.46-2.57-3.3s-2.62-1.27-4.38-1.27c-2.29,0-4.13,0.73-5.52,2.2
			c-1.39,1.47-2.09,3.54-2.09,6.23v4.73c0,2.69,0.7,4.76,2.09,6.23c1.39,1.47,3.23,2.2,5.52,2.2c0.91,0,1.78-0.12,2.61-0.35
			c0.83-0.24,1.55-0.58,2.17-1.04c0.62-0.46,1.12-1.03,1.49-1.71c0.37-0.68,0.56-1.48,0.56-2.39v-2.25h-5.96v-4.01h10.47v15.39h-4.1
			V212.64z'
        />

        <path
          d='M786.25,350.82c-2.43,0-4.49-0.44-6.18-1.32c-1.7-0.88-3.15-2.07-4.36-3.56l3.23-3.02
			c1.02,1.24,2.14,2.18,3.37,2.81c1.23,0.63,2.63,0.95,4.2,0.95c1.85,0,3.24-0.41,4.18-1.24c0.94-0.83,1.41-1.94,1.41-3.35
			c0-1.13-0.33-2.03-0.99-2.69c-0.66-0.66-1.83-1.16-3.52-1.49l-2.56-0.46c-2.81-0.52-4.92-1.45-6.33-2.77s-2.11-3.14-2.11-5.46
			c0-1.27,0.24-2.42,0.72-3.45s1.16-1.9,2.03-2.61c0.87-0.7,1.92-1.25,3.16-1.63c1.24-0.39,2.63-0.58,4.18-0.58
			c2.18,0,4.07,0.38,5.67,1.14c1.6,0.76,2.96,1.85,4.09,3.29l-3.27,2.9c-0.75-0.96-1.66-1.74-2.73-2.32s-2.41-0.87-4.01-0.87
			c-1.65,0-2.94,0.33-3.85,0.99c-0.91,0.66-1.37,1.63-1.37,2.9c0,1.21,0.37,2.12,1.12,2.71c0.74,0.59,1.9,1.04,3.47,1.34l2.56,0.54
			c2.9,0.55,5.01,1.49,6.35,2.81s2.01,3.14,2.01,5.46c0,1.35-0.24,2.58-0.7,3.68c-0.47,1.1-1.15,2.05-2.05,2.83
			c-0.9,0.79-1.99,1.39-3.29,1.82C789.38,350.6,787.91,350.82,786.25,350.82z'
        />
        <path
          d='M820.92,345.97h-0.17c-0.3,1.4-1.12,2.55-2.46,3.47s-3.11,1.38-5.32,1.38c-1.71,0-3.3-0.32-4.76-0.97
			c-1.46-0.65-2.72-1.6-3.79-2.85c-1.06-1.25-1.89-2.81-2.48-4.67s-0.89-4.01-0.89-6.43c0-2.4,0.3-4.53,0.91-6.39
			c0.61-1.86,1.46-3.43,2.56-4.7c1.1-1.27,2.43-2.23,3.97-2.88c1.54-0.65,3.27-0.97,5.17-0.97c2.59,0,4.78,0.57,6.58,1.71
			c1.79,1.14,3.19,2.73,4.18,4.77l-3.81,2.23c-0.55-1.36-1.41-2.46-2.57-3.3s-2.62-1.27-4.38-1.27c-2.29,0-4.13,0.73-5.52,2.2
			c-1.39,1.47-2.09,3.54-2.09,6.23v4.73c0,2.69,0.7,4.76,2.09,6.23c1.39,1.47,3.23,2.2,5.52,2.2c0.91,0,1.78-0.12,2.61-0.35
			c0.83-0.24,1.55-0.58,2.17-1.04c0.62-0.46,1.12-1.03,1.49-1.71c0.37-0.68,0.56-1.48,0.56-2.39v-2.25h-5.96v-4.01h10.47v15.39h-4.1
			V345.97z'
        />

        <path
          d='M797.94,479.31h-0.17c-0.3,1.4-1.12,2.55-2.46,3.47c-1.34,0.92-3.11,1.38-5.32,1.38
			c-1.71,0-3.3-0.33-4.76-0.97c-1.46-0.65-2.72-1.6-3.79-2.85c-1.06-1.25-1.89-2.81-2.48-4.67s-0.89-4.01-0.89-6.43
			c0-2.4,0.3-4.53,0.91-6.39c0.61-1.86,1.46-3.43,2.56-4.7c1.1-1.27,2.43-2.23,3.97-2.88c1.54-0.65,3.27-0.97,5.17-0.97
			c2.59,0,4.78,0.57,6.58,1.71c1.79,1.14,3.19,2.73,4.18,4.77l-3.81,2.23c-0.55-1.36-1.41-2.46-2.57-3.3s-2.62-1.27-4.38-1.27
			c-2.29,0-4.13,0.73-5.52,2.2s-2.09,3.54-2.09,6.23v4.73c0,2.69,0.7,4.76,2.09,6.23s3.23,2.2,5.52,2.2c0.91,0,1.78-0.12,2.61-0.35
			s1.55-0.58,2.17-1.04c0.62-0.46,1.12-1.03,1.49-1.71c0.37-0.68,0.56-1.48,0.56-2.39v-2.25h-5.96v-4.01h10.47v15.39h-4.1V479.31z'
        />
        <path d='M808.53,483.65v-28.87h4.67v24.74h11.75v4.14H808.53z' />

        <path
          d='M928.33,479.31h-0.17c-0.3,1.4-1.12,2.55-2.46,3.47c-1.34,0.92-3.11,1.38-5.32,1.38
			c-1.71,0-3.3-0.33-4.76-0.97c-1.46-0.65-2.72-1.6-3.79-2.85c-1.06-1.25-1.89-2.81-2.48-4.67s-0.89-4.01-0.89-6.43
			c0-2.4,0.3-4.53,0.91-6.39c0.61-1.86,1.46-3.43,2.56-4.7c1.1-1.27,2.43-2.23,3.97-2.88c1.54-0.65,3.27-0.97,5.17-0.97
			c2.59,0,4.78,0.57,6.58,1.71c1.79,1.14,3.19,2.73,4.18,4.77l-3.81,2.23c-0.55-1.36-1.41-2.46-2.57-3.3s-2.62-1.27-4.38-1.27
			c-2.29,0-4.13,0.73-5.52,2.2s-2.09,3.54-2.09,6.23v4.73c0,2.69,0.7,4.76,2.09,6.23s3.23,2.2,5.52,2.2c0.91,0,1.78-0.12,2.61-0.35
			s1.55-0.58,2.17-1.04c0.62-0.46,1.12-1.03,1.49-1.71c0.37-0.68,0.56-1.48,0.56-2.39v-2.25h-5.96v-4.01h10.47v15.39h-4.1V479.31z'
        />
        <path
          d='M943.6,483.65h-4.67v-28.87h12.45c2.59,0,4.63,0.78,6.12,2.34c1.49,1.56,2.23,3.67,2.23,6.35
			c0,2.07-0.48,3.79-1.43,5.15s-2.35,2.32-4.2,2.88l6.25,12.16h-5.21l-5.79-11.67h-5.75V483.65z M951.04,468.06
			c1.19,0,2.11-0.31,2.77-0.93c0.66-0.62,0.99-1.5,0.99-2.66v-1.98c0-1.15-0.33-2.04-0.99-2.66c-0.66-0.62-1.59-0.93-2.77-0.93
			h-7.45v9.14H951.04z'
        />
        <path
          d='M901.71,251.22l-2.61-7.82h-10.8l-2.52,7.82h-4.76l9.84-28.87h5.87l9.85,28.87H901.71z M893.81,226.65
			h-0.21l-4.18,12.74h8.52L893.81,226.65z'
        />
        <path
          d='M915.74,251.22h-4.67v-28.87h12.45c2.59,0,4.63,0.78,6.12,2.34s2.23,3.67,2.23,6.35
			c0,2.07-0.48,3.78-1.43,5.15s-2.35,2.32-4.2,2.88l6.25,12.16h-5.21l-5.79-11.67h-5.75V251.22z M923.18,235.62
			c1.19,0,2.11-0.31,2.77-0.93c0.66-0.62,0.99-1.5,0.99-2.66v-1.98c0-1.15-0.33-2.04-0.99-2.66c-0.66-0.62-1.59-0.93-2.77-0.93
			h-7.45v9.14H923.18z'
        />
        <path
          d='M961.48,312.04l-2.61-7.82h-10.8l-2.52,7.82h-4.76l9.84-28.87h5.87l9.85,28.87H961.48z M953.58,287.47
			h-0.21l-4.18,12.74h8.52L953.58,287.47z'
        />
        <path d='M969.59,312.04v-3.81h3.93v-21.26h-3.93v-3.81h12.58v3.81h-3.97v21.26h3.97v3.81H969.59z' />
      </g>
    </svg>
  )
}
